import http from '@/http';
import fnc from '@/fnc'


export default {
    namespaced:true,
    state: {
        token       : localStorage.getItem('gToken') || false,
        userData    : localStorage.getItem('gToken') ? fnc.tokenParser(localStorage.getItem('gToken')) : [],
        logoutMsg   : null
    },
    actions:{
        login({commit}, formData){
            return http.post('auth/guestLogin',formData).then(res => {
                if(res.success){
                    commit('LOGIN_SUCCESS',res.payload);
                }else{
                    commit("LOGOUT");
                }
                return Promise.resolve(res);
            });
        },
        logout({state,commit},msg){
            state.logoutMsg = msg;
            commit("LOGOUT");
        },
        checkAuthToken({state,dispatch},msg='Giriş yapınız...'){
            if(state.token !== false){
                if(Date.now() >= state.userData.exp * 1000){
                    dispatch('logout',msg);
                }
            }
        }
    },
    mutations:{
        LOGIN_SUCCESS(state,tokenData){
            localStorage.setItem('gToken',tokenData);
            state.token         = tokenData;
            state.userData      = fnc.tokenParser(tokenData);
        },
        LOGOUT(state){
            localStorage.removeItem('gToken');
            state.token         = false;
            state.userData      = [];
            state.userRoleMenu  = null;
        }
    },
    getters:{
        getToken            : (state) => state.token,
        userData            : (state) => state.userData,
        isLoggedIn          : (state) => !!state.token,
        logoutMsg           : (state) => state.logoutMsg,
    }


}